var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vtotal"},[_c('div',{staticClass:"vtotal__info"},[_c('div',{staticClass:"vtotal__label"},[_vm._t("label")],2),_c('div',{staticClass:"vtotal__amount"},[_vm._t("amount")],2)]),_c('div',{staticClass:"vtotal__icon"},[_c('total-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        classes: ['tooltip--reset-margin'],
        content: 'Tax excluded',
      }),expression:"{\n        classes: ['tooltip--reset-margin'],\n        content: 'Tax excluded',\n      }"}],attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }